module.exports = __webpack_public_path__ + "static/media/loader.f63727fb.svg";